import { FC, PropsWithChildren, useCallback, useMemo } from 'react';
import { RepurchasePricingContext } from '@/data/context/RepurchasePricing';
import { usePersonalizationPercentage } from '@/data/Content/RepurchaseCoupon';
import { useRepurchaseExclusions } from '@/data/Content/RepurchaseExclusions';
import { ExclusionProduct } from '@/data/Content/RepurchaseExclusionRules';

export const RepurchasePricingProvider: FC<
	PropsWithChildren<{ products: ExclusionProduct[]; excludedPartNumber?: string }>
> = ({ products, excludedPartNumber, children }) => {
	const percentage = usePersonalizationPercentage();
	const { isExcluded: isExcludedByRules } = useRepurchaseExclusions(products);
	const isExcluded = useCallback(
		(product: ExclusionProduct) =>
			product.partNumber === excludedPartNumber || isExcludedByRules(product),
		[excludedPartNumber, isExcludedByRules]
	);
	const value = useMemo(
		() => (percentage ? { percentage, isExcluded } : undefined),
		[percentage, isExcluded]
	);

	return (
		<RepurchasePricingContext.Provider value={value}>{children}</RepurchasePricingContext.Provider>
	);
};
